export default ({ request }) => ({
    ecomAmzRecordAdvListApi(data = {}) {
        return request({
            url: '/ecom/amz/record/adv/list',
            method: 'POST',
            data,
        })
    },
})
